import React, { useState } from "react";
import { Modal, Button, Input, Popconfirm, message } from "antd";
import { SearchOutlined, DeleteOutlined } from "@ant-design/icons";
import { useDispatch } from "react-redux";
import "../css/notifications.css";
import FreemiumTable from "./FreemiumTable";
import Clipboard from "../assets/icons/voyages/clipboard-import.svg";
import EmissionsReport from "../pages/freemium/EmissionsReport";
import { delete_estimation_handler, fetchFreemiumReportData } from '../features/Voyage/VoyageSlice';

const FreemiumTabComponent = ({ showModal, setShowModal }) => {
  const [showEmissionModal, setShowEmissionModal] = useState(false);
  const [selectedReport, setSelectedReport] = useState(null);
  const [searchText, setSearchText] = useState("");
  const dispatch = useDispatch();

  const handleCloseTableModal = () => {
    setShowModal(false);
    setSearchText("");
  };

  const handleDownload = (record) => {
    setSelectedReport(record);
    setShowEmissionModal(true);
  };

  // Generate report_id in format: VESSEL_NAME_YYYYMMDD_HHMMSS
 

const handleDelete = async (record) => {
  try {
    if (record?._local) {
      message.warning("This report is not saved on server yet");
      return;
    }

    const report_id = record?.report_id;

    if (!report_id) {
      message.error("Missing report ID");
      return;
    }

    console.log("Deleting report_id:", report_id);

await dispatch(delete_estimation_handler({ report_id })).unwrap();

    message.success("Report deleted successfully");

    dispatch(fetchFreemiumReportData());
  } catch (error) {
    console.error("Delete error:", error);
    message.error(
      typeof error === "string" ? error : "Failed to delete report"
    );
  }
};



  const freemiumData = [
    {
      title: "IMO Number",
      dataIndex: "imo_number",
    },
    {
      title: "Vessel Name",
      dataIndex: "vessel_name",
    },
    {
      title: "Date Created",
      dataIndex: "created_at",
      render: (date) => {
        if (!date) return "-";
        const dateObj = new Date(date);
        return dateObj.toLocaleDateString("en-CA");
      },
    },
    {
      title: "Download",
      render: (_, record) => {
        const isProcessing = record?.status !== 200;
        const hasData = record?.table_data?.length > 0;

        return (
          <Button
            type="link"
            icon={
              <img 
                src={Clipboard} 
                alt="clipboard" 
                style={{ 
                  filter: "brightness(0) saturate(100%) invert(36%) sepia(95%) saturate(1893%) hue-rotate(199deg) brightness(98%) contrast(101%)" 
                }}
              />
            }
            disabled={isProcessing || !hasData}
            title={
              isProcessing
                ? "Report is still being generated"
                : !hasData
                ? "No report data available"
                : "Download Emissions Report"
            }
            onClick={() => handleDownload(record)}
            style={{ padding: 0 }}
          />
        );
      },
    },
{
  title: "Delete",
  render: (_, record) => {
    const canDelete = !!record.report_id && !record._local;

    return (
      <Popconfirm
        title="Delete Report"
        description="Are you sure you want to delete this report?"
        onConfirm={() => handleDelete(record)}
        okText="Yes"
        cancelText="No"
        okButtonProps={{ danger: true }}
        disabled={!canDelete}
      >
        <Button
          type="link"
          icon={<DeleteOutlined />}
          danger
          disabled={!canDelete}
          title={
            canDelete
              ? "Delete Report"
              : "Cannot delete unsaved report"
          }
          style={{ padding: 0 }}
        />
      </Popconfirm>
    );
  },
}


  ];

  return (
    <>
      {/* PREVIOUS REPORTS TABLE */}
      <Modal
        title={
          <div style={{ marginBottom: 16 }}>
            <div style={{ marginBottom: 12 }}>Previous Reports</div>
            <Input
              placeholder="Search by IMO Number or Vessel Name"
              prefix={<SearchOutlined />}
              value={searchText}
              onChange={(e) => setSearchText(e.target.value)}
              allowClear
              style={{ width: "100%" }}
            />
          </div>
        }
        width="60%"
        footer={null}
        open={showModal}
        onCancel={handleCloseTableModal}
        destroyOnClose
      >
        <FreemiumTable 
          closeModal={handleCloseTableModal} 
          columns={freemiumData}
          searchText={searchText}
        />
      </Modal>

      {/* EMISSIONS REPORT MODAL */}
      <Modal
        open={showEmissionModal}
        onCancel={() => setShowEmissionModal(false)}
        footer={null}
        width={1200}
        centered
        destroyOnClose
        closeIcon={
          <span style={{ fontSize: "15px", color: "red", background: "white" }}>
            ✕
          </span>
        }
      >
        {selectedReport && <EmissionsReport data={selectedReport} />}
      </Modal>
    </>
  );
};

export default FreemiumTabComponent;